import { put, takeLatest, call } from 'redux-saga/effects';
import { authActions } from 'src/store/auth/auth.actions';
import { backendUrl } from 'src/config';
import Cookies from 'js-cookie';
import qs from 'qs';

import axiosInstance from 'src/axios-instance';

export const threeHundredAndSixtyFiveDays = 365;

function* sendForgotEmail(action) {
  try {
    yield axiosInstance.request({
      method: 'POST',
      url: `${backendUrl}/api/forgot_password`,
      data: qs.stringify({ username: action.payload.username }),
    });

    yield put(authActions.sendForgotPasswordEmailSuccess());
  } catch (error) {
    yield put(
      authActions.sendForgotPasswordEmailFailure({
        errorcodes: error && error.response ? error.response.errorcodes : [],
      }),
    );
  }
}

function* confirmedProfileInformation(action) {
  try {
    yield axiosInstance.request({
      method: 'POST',
      url: `${backendUrl}/api/profile/confirm_information`,
      withCredentials: true,
    });

    yield put(authActions.userConfirmedProfileInformationSuccess());
    if (action.payload.onSuccess) {
      action.payload.onSuccess();
    }
  } catch (error) {
    yield put(authActions.userConfirmedProfileInformationError());
  }
}

function* login(action) {
  const { username, password } = action.payload;
  try {
    const loginRequest = yield call(() => axiosInstance
      .request({
        method: 'POST',
        url: `${backendUrl}/api/login`,
        params: {
          username,
          password,
        },
        withCredentials: true,
      })
      .then((r) => r));

    if (
      loginRequest.request.status === 200
      || loginRequest.request.status === 418
    ) {
      yield put({ type: 'RESET_STORE' });
      Cookies.set('logged-in', true, {
        expires: threeHundredAndSixtyFiveDays,
      });
      yield put(authActions.loginSuccess());
      if (loginRequest.request.status === 418) {
        yield put(authActions.userNeedsToConfirmProfileInformation());
      }
    }
    if (
      loginRequest.request.status === 401
      || loginRequest.request.status === 500
    ) {
      yield put(
        authActions.loginFailure({
          errorcodes: loginRequest.data
            ? loginRequest.data.errorcodes
            : ['UNAUTHORIZED'],
        }),
      );
    }
  } catch (err) {
    console.error(err);
    yield put(
      authActions.loginFailure({
        errorcodes:
          err.response && err.response.data
            ? err.response.data.errorcodes
            : ['UNAUTHORIZED'],
      }),
    );
  }
}

function* logout(action) {
  try {
    yield call(() => axiosInstance
      .request({
        method: 'POST',
        url: `${backendUrl}/api/logout`,
        withCredentials: true,
      })
      .then(({ data }) => data));
    yield put(authActions.logoutSuccess());
  } catch (err) {
    yield put(authActions.logoutFailure({ errorcodes: [] }));
  } finally {
    Cookies.remove('logged-in');
    localStorage.removeItem('impersonateUsername');
    yield put({ type: 'RESET_STORE' });
  }
}

/**
 * Used for both chaning password while user is logged in(with session-cookie for auth)
 * and for resettign the password with a new one(with url-token from url sent by email for auth)
 */
function* changePassword(action) {
  const kind = action.payload.kind;
  try {
    yield call(() => axiosInstance
      .request({
        method: 'POST',
        url: `${backendUrl}/api/${
            kind === 'CHANGE' ? 'profile/change_password' : 'set_new_password'
          }`,
        withCredentials: kind === 'CHANGE',
        data: qs.stringify(
          kind === 'CHANGE'
            ? {
              password: action.payload.password,
              new_password: action.payload.new_password,
            }
            : {
              new_password: action.payload.new_password,
              t: action.payload.t,
            },
        ),
      })
      .then(({ data }) => data));
    if (action.onSuccess) {
      action.onSuccess();
    }
    yield put(authActions.changePasswordSuccess());
  } catch {
    if (action.onError) {
      action.onError();
    }
    yield put(authActions.changePasswordFailure());
  }
}

export default [
  takeLatest(authActions.sendForgotPasswordEmail().type, sendForgotEmail),
  takeLatest(authActions.changePassword().type, changePassword),
  takeLatest(authActions.login().type, login),
  takeLatest(authActions.logout().type, logout),
  takeLatest(
    authActions.userConfirmedProfileInformation().type,
    confirmedProfileInformation,
  ),
];
